module.exports = __webpack_public_path__ + "img/flusher_driving.1fd95225.svg";